import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { KidzkulamLogo } from "@/components/Logo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PublicUpdate() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    axios.get(`${API}/shared/daily-update/${token}`)
      .then((r) => setData(r.data))
      .catch(() => setErr("This share link has expired or is invalid."));
  }, [token]);

  if (err) {
    return (
      <div className="min-h-screen grid place-items-center bg-background p-6">
        <div className="max-w-md text-center space-y-4">
          <KidzkulamLogo size={54} />
          <div className="text-lg font-bold text-destructive">{err}</div>
          <div className="text-sm text-muted-foreground">Please ask the school for a fresh link.</div>
        </div>
      </div>
    );
  }
  if (!data) return <div className="min-h-screen grid place-items-center text-muted-foreground">Loading...</div>;

  const { update, class_name, child_name } = data;

  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-2xl mx-auto p-6 md:p-10">
        <div className="flex justify-between items-center mb-8">
          <KidzkulamLogo size={44} />
          <span className="chip-green px-3 py-1 rounded-full text-xs font-bold uppercase tracking-widest">Shared</span>
        </div>

        <div className="card-soft rounded-3xl p-6 md:p-8 animate-float-in">
          <div className="text-sm font-bold uppercase tracking-widest text-primary/80">
            {class_name || "Kidzkulam"} · {update.date}
          </div>
          <h1 className="text-3xl md:text-4xl font-black mt-2">
            {child_name ? `A little update about ${child_name}` : "Today at Kidzkulam"}
          </h1>
          <p className="text-lg leading-relaxed mt-5 font-medium">{update.activity_note}</p>
          {update.meal_note && (
            <div className="mt-4 rounded-2xl bg-muted/60 p-4 text-sm">
              <span className="font-bold">🍎 Meal:</span> {update.meal_note}
            </div>
          )}

          {update.photos?.length > 0 && (
            <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 gap-3">
              {update.photos.map((p) => (
                <img
                  key={p}
                  src={`${API}/shared/file/${token}?path=${encodeURIComponent(p)}`}
                  alt="Update"
                  className="w-full aspect-square object-cover rounded-2xl"
                />
              ))}
            </div>
          )}

          <div className="mt-8 pt-6 border-t border-border text-sm text-muted-foreground">
            Posted by {update.posted_by || "Kidzkulam"} · with love from your child's class
          </div>
        </div>

        <div className="mt-8 text-center text-xs font-semibold text-muted-foreground tracking-widest uppercase">
          Kidzkulam · Let's Make Future
        </div>
      </div>
    </div>
  );
}
